'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    OverridesContext: function() {
        return OverridesContext;
    },
    OverridesProvider: function() {
        return OverridesProvider;
    },
    useOverrides: function() {
        return useOverrides;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const OverridesContext = _react.createContext(undefined);
const OverridesProvider = OverridesContext.Provider;
function useOverrides() {
    var _React_useContext;
    return (_React_useContext = _react.useContext(OverridesContext)) !== null && _React_useContext !== void 0 ? _React_useContext : {};
}
